import { createContext } from "react";
import { baseTheme } from "../../../styles/theme";

export const HeaderColorContext = createContext(baseTheme.colors.black);
